import {Module} from 'vuex'
import {state} from './state'
import {ICategoriesStateModel, IRootStateModel} from './../../interfaces'
import { mutations } from './mutations'
import { getters } from './getters'
import { actions } from './actions'

const comments: Module<ICategoriesStateModel, IRootStateModel> = {
    state,
    mutations,
    getters,
    actions
}

export default comments;